<template>
  <v-card>
    <v-toolbar>
      <div class="w-100 d-flex justify-space-between">
        <div class="d-flex align-center font-weight-bold text-lg">
          Vinculados
        </div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="rgb(78, 191, 83)" dark v-bind="attrs" v-on="on">
              Filtrar
            </v-btn>
          </template>

          <v-card class="px-2 py-2">
            <h4 class="mb-1">Filtrar</h4>
            <v-text-field outlined placeholder="nome" v-model="filter.nome" />
            <v-btn @click="clearFilters" plain>Limpar</v-btn>
          </v-card>
        </v-menu>
      </div>
    </v-toolbar>
    <v-list class="scroll-list">
      <v-list-item v-for="item in itensFiltrados" :key="item.id">
        <v-list-item-content>
          <div class="d-flex list-div pr-2">
            <v-btn icon @click="unlinkCentroCusto(item.id)">
              <v-icon color="black">mdi-arrow-left-bold</v-icon>
            </v-btn>
            <v-list-item-title
              class="text-right"
              v-text="item.cod_centro_custo + ' - ' + item.centro_custo"
            ></v-list-item-title>
          </div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import toast from "@/commom/toast";
import CentroCustoEmpresa from "../../../../services/http/nfeNcm/CentroCustoEmpresa";
export default {
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      menu: false,
      teste: "",
      filter: {
        nome: "",
      },
    };
  },
  methods: {
    clearFilters() {
      this.filter = {
        nome: "",
        codigo: "",
      };
    },
    async unlinkCentroCusto(id) {
      try {
        await CentroCustoEmpresa(id).update({
          status: false,
        });
        this.$emit("onLinkEnd");
        toast("success", "Sucesso ao desvincular: ");
      } catch (e) {
        toast("error", "Não foi possivel desvincular");
      }
    },
  },
  computed: {
    itensFiltrados() {
      let itens = this.items;

      if (this.filter.nome) {
        itens = itens.filter((item) =>
          item.centro_custo.includes(this.filter.nome)
        );
      }
      return itens;
    },
  },
};
</script>
<style scoped>
.list-div {
  border: 1px dashed gray;
  padding-left: 0.5rem;
}
.scroll-list {
  max-height: 65vh !important;
  overflow-y: scroll !important;
}
</style>
